import * as angular from 'angular';
import * as _ from 'lodash';
import ReportResource from '../models/report-resource';
import ResourceService from './resource.service';

export default class ReportService extends ResourceService<ReportResource> {
  constructor(private BackendService: any) {
    super(BackendService, ReportResource);
  }
}

angular.module('ciApp.services').service('ReportService', ['BackendService', ReportService]);



// WEBPACK FOOTER //
// ./common/services/report.service.ts